// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yntmr","controls":"styles_controls__X3nzi","charLimit":"styles_charLimit__3la7o","input":"styles_input__3KtA7","send":"styles_send__16UDR"};